import { ConfTable } from './table';

export default ConfTable;
